<template>
  <v-container>
    <Dialog
      :show="adDialog"
      :object="objDelete"
      @delete="eliminar"
      @close="close"
    />
    <Modal
      @save="guardar"
      @close="close"
      :object="itemAct"
      :update="update"
      :detalle="detalle"
      :show="abrirModal"
    />
    <template>
      <v-row>
        <v-col cols="12" md="11">
          <span class="align-center headline">
            Coches
          </span>
        </v-col>
        <v-col cols="12" md="1">
          <v-btn color="primary" dark class="mb-2" @click="nuevo">Nuevo</v-btn>
        </v-col>
      </v-row>
    </template>
    <Table
      @edit="editarClick"
      @delete="eliminarClick"
      @detalle="detalleClick"
      :headers="headers"
      :arrayList="coches"
      :opciones="true"
      :title="alquilerStr"
      :coche="true"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Table from "@/components/base/Table.vue";
import Modal from "@/components/base/modal/ModalCoche.vue";
import Dialog from "@/components/base/Dialog";
import Headers from "../headers"
import moment from "moment";

export default {
  data() {
    return {
      headers: Headers.headersCoches,
      modoChart: "column",
      abrirModal: false,
      ventaStr: 'Coches a la venta',
      alquilerStr: 'Todos los coches',
      itemAct: {
        grupo:null,
        dalquiler:true,
        aventa:null,
        taller:null,
        vendido:null,  
        matricula:null,
        marca:null,
        modelo:null,
        color:null,
        bastidor:null,
        puertas:null,
        km_actual:null,
        km_compra:null,
        tanque:null,
        tipo_combustible:null,
        combustible_actual:null,
        gas:null,
        radio:null,
        plazas:null,
        fecha_compra:moment( new Date() ).format('LL'),
        fecha_alta:moment( new Date() ).format('LL'),
        fecha_matriculacion:moment( new Date() ).format('LL'),
        fecha_limite:moment( new Date() ).format('LL'),
        fecha_itv:moment( new Date() ).format('LL'),
        precio_compra:null,
        precio_venta:null,
        imagen:null,
        observaciones:null,
      },
      objDelete: {
        element: 'Coche',
        id: '',
        obj: {}
      },
      update: false,
      detalle: false,
      adDialog: false,
    };
  },
  components: {
    Table,
    Modal,
    Dialog,
  },
  async created() {
    moment.locale("ES");
    // this.calcularDeuda();
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario"]),
    ...mapState("cocheNamespace", ["coche", "coches"]),
  },
  methods: {
    ...mapActions("cocheNamespace", [
      "getCoche",
      "getCoches",
      "saveCoche",
      "updateCoche",
      "deleteCoche",
      "deactivateCoche",
      "activateCoche",
    ]),
    editarClick(obj) {
      this.update = true;
      this.detalle = false;
      this.itemAct = obj;
      this.abrirModal = true;
    },
    detalleClick(obj) {
      this.detalle = true;
      this.itemAct = obj;
      this.abrirModal = true;
    },
    eliminarClick(obj) {
      this.adDialog = true;
      this.objDelete.id = obj.id;
      this.objDelete.obj = obj
    },
    nuevo() {
      this.update = false;
      this.abrirModal = true;
    },
    guardar(obj) {
      if (this.update) {
        this.updateCoche({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      } else {
        this.saveCoche({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      }
      this.close();
      this.getCoches();
    },
    eliminar(obj) {
      this.deleteCoche({
        token: this.token,
        id: obj,
      });
      this.close();
    },
    close() {
      this.detalle = false;
      this.update = false;
      this.itemAct = {};
      this.abrirModal = false;
      this.adDialog = false;
    },
  },
};
</script>
